<template>
  <div class="pay_cont creditcard target_apaycreditcard">
    <div class="row card-method">
      <div id="paymentPanel02">
        <div class="swiper mySwiper card-swiper type-gray">
          <div class="swiper-wrapper" v-if="haveCard">

            <Flicking
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
              @changed="onSlideChange"
              @select="onSlideSelect"
              @ready="onSwiperReady"
            >
              <card-slider
                v-for="(card, index) in cards"
                :key="index"
                :class="index === activeIndex ? 'swiper-slide-active' : ''"
                :card="card" />

              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>

          <div class="swiper-wrapper" v-else>

            <Flicking
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
            >
              <div class="swiper-slide" style="width: 302px !important; padding: 0 8px;">
                <div class="payment-unit">
                  <a class="payment-link">
                    <div
                      class="payment-card card-area">
                      <p>
                        등록된 A Pay 계좌/카드가 없습니다.<br>
                        암웨이 홈페이지에서 등록 후 사용해주세요.
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>

        </div>

        <div class="payment-select">
          <select
            :disabled="!canInstalling"
            v-model="selectedAmwayPayInstallPlan"
            class="form-control no-uppercase-form-control"
            @change="updateInstallmentPlan"
            aria-hidden="true"
          >
            <option :selected="`true`" :value="0">일시불</option>
            <option v-for="(month, index) in amwayPayInstallPlans" :key="index" :value="month">
              {{ `${month}개월` }}
            </option>
          </select>
        </div>


      </div>
    </div>
  </div>

</template>

<script>
import CardSlider from "@/views/order/main/components/Payment/CardSlider";
import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
import { Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";
import { log } from "@/utils/common";
import { mapGetters } from 'vuex';

export default {
  name: "AmwayPayCard",
  components: {
    Flicking,
    CardSlider,
  },
  props: {
    amwayPayCards: {
      type: Object,
      required: true,
    },
    canInstalling: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedParty: "amwaypay/selectedParty",
    }),
    cards() {
      return this.selectedParty === 0 ? this.amwayPayCards.masterParty : this.amwayPayCards.subParty;
    },
    haveCard() {
      return this.cards.length > 0;
    },
  },
  data() {
    return {
      plugins: [
        new Arrow({
          prevElSelector: '.swiper-button-prev',
          nextElSelector: '.swiper-button-next'
        }),
      ],
      activeIndex: 0,
      swiperOptions: {
        align: 'center',
        circular: false,
        panelsPerView: -1,
        noPanelStyleOverride: false,
      },
      amwayPayInstallPlans: [...Array(13).keys()].filter(i => i >= 2),
      selectedAmwayPayInstallPlan: 0,
    }
  },
  methods: {
    onSlideChange(data) {
      this.activeIndex = data.index;
      this.chooseCard(this.activeIndex);
    },
    onSlideSelect(data) {
      this.activeIndex = data.index;
      data.panel.focus(300);
      this.chooseCard(this.activeIndex);
    },
    onSwiperReady(event) {
      event.currentTarget.currentPanel.focus(300)
      this.chooseCard(event.currentTarget.currentPanel.index);
    },
    chooseCard(index) {
      const selectedCard = this.cards[index];
      this.$store.commit('amwaypay/selectAmwayPayCard', selectedCard)
      log("ChooseAPayCard:: ", selectedCard);
    },
    updateInstallmentPlan() {
      this.$store.commit("amwaypay/updateAmwayPayInstallmentPlan", this.selectedAmwayPayInstallPlan);
    }
  },
}
</script>

<style scoped>

</style>
